export const screenConstants = {
    UPDATE_SCREEN_SIZE: 'UPDATE_SCREEN_SIZE',
};
